<template>
  <!--
    TEMPORARY: Invoices section disabled for extraordinary maintenance.
    To re-enable: restore `<router-view />` below, remove the
    <InvoicesMaintenanceModal /> line + its import/registration, and delete
    src/components/InvoicesMaintenanceModal.vue (and the `invoicesMaintenance`
    i18n keys).
  -->
  <InvoicesMaintenanceModal />
  <!-- <router-view /> -->
</template>

<script>
import InvoicesMaintenanceModal from '@/components/InvoicesMaintenanceModal.vue';

export default {
  name: 'Invoices',
  components: {
    InvoicesMaintenanceModal,
  },
};
</script>
